import React from "react";
import Modal from "react-bootstrap/Modal";
import TableHistoryOrderProductTable from "components/Tables/TableHistoryOrderProductTable";

import { useTranslation } from "react-i18next";

export default function TableHistoryModal({ people, user, tableHistoryId, show, handleClose }) {
  const {
    t,
  } = useTranslation();

  return (
    <>
      <Modal size="xl" dialogClassName="my-modal" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ margin: 0 }}>
            {t("tables.headers.peopleSuffix")}{people}{t("tables.headers.userSuffix")}{user}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TableHistoryOrderProductTable modalOpen={show} tableHistoryId={tableHistoryId} />
        </Modal.Body>
      </Modal>
    </>
  );
}
